import { render, staticRenderFns } from "./CoverPage.vue?vue&type=template&id=32e4cf04&scoped=true&"
import script from "./CoverPage.vue?vue&type=script&lang=js&"
export * from "./CoverPage.vue?vue&type=script&lang=js&"
import style0 from "./CoverPage.vue?vue&type=style&index=0&id=32e4cf04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4cf04",
  null
  
)

export default component.exports